import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
} from '@chakra-ui/react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Props = {
  options: string[]
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function ScoreOptionsForm({ formMethods, options }: Props) {
  function handleInputOnBlur() {
    const newScoreSettings = options.map((option, index) => {
      const scoreOption = formMethods.watch(`score_${index}`)
      return { key: option, value: Number(scoreOption) || 0 }
    })
    formMethods.setValue('score_settings', { options: newScoreSettings })
  }

  return (
    <Stack>
      {options.map((option, index) => (
        <FormControl key={option} display="flex" flexDir="column" gap={2}>
          <FormLabel fontWeight="bold">{option}</FormLabel>
          <NumberInput onBlur={handleInputOnBlur} defaultValue={0}>
            <NumberInputField {...formMethods.register(`score_${index}`)} />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </FormControl>
      ))}
    </Stack>
  )
}
